import { bayer } from "../shared/color";
import { CELL } from "../shared/defs";
import type { World } from "./world";

type CarveCell = (x: number, y: number, color: number, mat: number, owner: number) => void;

/**
 * Meteor crater: a lumpy ellipse along the incoming heading, with a dithered
 * rim and three short nubs. No long arms.
 */
export function meteorPit(world: World, x: number, y: number, radius: number, heading: number, on?: CarveCell) {
  const rad = radius / CELL;
  const cx = x / CELL;
  const cy = y / CELL;
  const c = Math.cos(heading);
  const s = Math.sin(heading);
  const stretch = 1.18;
  const lobes = 4 + Math.floor(Math.random() * 4);
  const phase = Math.random() * Math.PI * 2;
  const reach = Math.ceil(rad * stretch + rad * 0.35) + 2;
  world.carveWhere(
    Math.floor(cx) - reach,
    Math.floor(cy) - reach,
    Math.floor(cx) + reach,
    Math.floor(cy) + reach,
    (col, row) => {
      const dx = col + 0.5 - cx;
      const dy = row + 0.5 - cy;
      const lx = dx * c + dy * s;
      const ly = -dx * s + dy * c;
      const dist = Math.hypot(lx / stretch, ly);
      const ang = Math.atan2(ly, lx / stretch);
      const wobble = 1
        + 0.07 * Math.sin(lobes * ang + phase)
        + 0.035 * Math.sin((lobes + 3) * ang - phase * 1.3);
      const edge = rad * wobble;
      if (dist <= edge - 1.1) return true;
      if (dist >= edge + 0.9) return false;
      return bayer(col, row) < (edge + 0.9 - dist) / 2;
    },
    on,
  );
  for (let i = 0; i < 3; i++) {
    const ang = phase + i * 2.15 + Math.random() * 0.4;
    const nub = radius * (0.1 + Math.random() * 0.08);
    const dist = radius * 0.98;
    world.carve(x + Math.cos(heading + ang) * dist, y + Math.sin(heading + ang) * dist, nub, 0.15, on);
  }
}
